export const toCurrency = (value?: number) => {
  if (value === null || value === undefined) {
    return '';
  }

  const brlValue = value.toLocaleString('pt-br', {
    style: 'currency',
    currency: 'BRL',
  });

  return brlValue;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeNoNumericValues = <T = any>(value?: T) => {
  if (value === undefined || value === null) {
    return value;
  }

  return String(value)
    .toString()
    .replace(/[^\d]+/g, '');
};

export const toNumberValue = (value: string) => {
  try {
    value = value.toString().replace(/"/g, '');
    if (value.toString().indexOf(',')) {
      value = value.toString().replace(/,/g, '.');
    }

    return parseFloat(parseFloat(value).toFixed(2));
  } catch (ex) {
    return 0;
  }
};
